import { __decorate } from "tslib";
import { AutoEncoder, BooleanDecoder, field, StringDecoder } from '@simonbackx/simple-encoding';
export class OrganizationDomains extends AutoEncoder {
    registerDomain = null;
    /**
     * Used for sending emails. Use of subdomain is discouraged, because that sends emails from @sub.domain.com instead of @domain.com
     */
    mailDomain = null;
    /**
     * Use shorter DKIM key (1024 bit) instead of 2048 bit
     */
    useDkim1024bit = false;
}
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], OrganizationDomains.prototype, "registerDomain", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], OrganizationDomains.prototype, "mailDomain", void 0);
__decorate([
    field({ decoder: BooleanDecoder, optional: true, version: 177 })
], OrganizationDomains.prototype, "useDkim1024bit", void 0);
//# sourceMappingURL=OrganizationDomains.js.map